import { render, staticRenderFns } from "./PermissionsTable.vue?vue&type=template&id=2ca7e2a3"
import script from "./PermissionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PermissionsTable.vue?vue&type=style&index=0&id=2ca7e2a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports